import apiClient from "@/services/api-client";
import type {
  ImpersonationLogResponse,
  ImpersonationStartPayload,
  ImpersonationStartResponse,
} from "@/types";

export const impersonationService = {
  start: async (payload: ImpersonationStartPayload) => {
    const response = await apiClient.post<ImpersonationStartResponse>(
      "/impersonation/start",
      payload,
    );
    return response.data;
  },
  stop: async (logId: string) => {
    const response = await apiClient.post("/impersonation/stop", { logId });
    return response.data;
  },
  listLogs: async (params?: { page?: number; limit?: number }) => {
    const response = await apiClient.get<ImpersonationLogResponse>(
      "/impersonation/logs",
      { params },
    );
    return response.data;
  },
};
